var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trinity-rings-spinner"},[_c('div',{staticClass:"circle"}),_c('div',{staticClass:"circle"}),_c('div',{staticClass:"circle"})])
}]

export { render, staticRenderFns }